<template>
  <table class="bonus-table">
    <thead>
      <tr>
        <th class="min-value-th">Valor mínimo da lista</th>
        <th class="bonus-th">Benefício</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in tableData" :key="index">
        <td class="min-value-td">{{ row.minValue }}</td>
        <td class="bonus-td">{{ row.bonus }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'BonusTable',

  props: {
    rows: {
      type: Array,
      required: true
    }
  },

  computed: {
    tableData() {
      return this.rows
    }
  }
}
</script>

<style lang="scss" scoped>
.bonus-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;

  th,
  td {
    padding: 16px 8px;
    border-left: 1px solid #F4CBD8;
    border-right: 1px solid #F4CBD8;

    border-bottom: 1px solid #D4DBE3;
    text-align: center;
    vertical-align: middle;
  }

  th {
    border-bottom: 1px solid #F4CBD8;
    border-top: 1px solid #F4CBD8;
    height: 86px;
    font-weight: 700;
    font-size: 18px;
  }

  td {
    background-color: #FFFFFF;
    font-size: 14px;
    height: 86px;
  }


  .min-value-th {
    background-color: #F8DFE7;
    color: #E583A2;
    border-top-left-radius: 8px;
    width: 50%;
    border-right: 1px solid #F4CBD8;
  }

  .bonus-th {
    background-color: #E583A2;
    color: #FFF;
    border-top-right-radius: 8px;
    width: 50%;
  }

  .min-value-td {
    width: 50%;
    border-right: 1px solid #F4CBD8;
    border-left: 1px solid #F4CBD8;
  }

  .bonus-td {
    border-right: 1px solid #F4CBD8;
    color: #3DAFB0;
    font-weight: 700;
    width: 50%;
  }

  tbody tr:last-child td {
    border-bottom: 1px solid #F4CBD8;
  }

  tbody tr:last-child .min-value-td {
    border-bottom-left-radius: 8px;
  }

  tbody tr:last-child .bonus-td {
    border-bottom-right-radius: 8px;
  }

}

@media (max-width: 800px) {
  .bonus-table {
    th {
      font-size: 16px;
    }
  }
}
</style>